import React from "react"
import { MdOutlineClose } from "react-icons/md"
import "./featureToolTip.scss"

const FeatureTooltip = (props) => {
  const { title, content, isOpen } = props

  return (
    <div className="tooltipContainer" data-cy="tooltip-container">
      <div className="tooltipArrow"></div>
      <div className="tooltipDetails">
        <div className="tooltipTitleBar">
          <span className="tooltipTitle">{title}</span>
          <span
            className="tooltipClose"
            data-cy="tooltip-close"
            onClick={() => isOpen(false)}
          >
            <MdOutlineClose />
          </span>
        </div>
        <div className="tooltipContent">{content}</div>
      </div>
    </div>
  )
}

export default FeatureTooltip
